import api from './api';

/**
 * Obtiene el estado actual del lobby para un juego específico.
 * @param {string} gameId - El ID del juego.
 * @returns {Promise<object>} El objeto del estado del lobby.
 */
export const getLobbyState = async (gameId) => {
  const response = await api.get(`/api/games/${gameId}/lobby`);
  // Return both lobby and player_rosters
  return {
    ...response.data.lobby,
    player_rosters: response.data.player_rosters || {},
  };
};

/**
 * Establece el estado de "listo" de un jugador en el lobby.
 * @param {string} gameId - El ID del juego.
 * @param {boolean} isReady - El nuevo estado de listo.
 * @returns {Promise<object>} La respuesta completa de la API.
 */
export const setReadyStatus = async (gameId, isReady) => {
  const response = await api.post(`/api/games/${gameId}/ready`, { is_ready: isReady });
  return response;
};

/**
 * Inicia el juego desde el lobby.
 * @param {string} gameId - El ID del juego.
 * @returns {Promise<object>} La respuesta completa de la API.
 */

export const startGame = async (gameId) => {
  const response = await api.post(`/api/games/${gameId}/start`);
  return response;
};

/**
 * Actualiza la configuración del bot en el lobby.
 * @param {string} gameId - El ID del juego.
 * @param {object} config - La configuración del bot { spawn_mode, unit_combo }
 * @returns {Promise<object>} La respuesta completa de la API.
 */
export const updateBotConfig = async (gameId, config) => {
  const response = await api.patch(`/api/games/${gameId}/bot-config`, config);
  return response;
};

/**
 * Obtiene las plantillas de loadout disponibles para AI.
 * @param {string} gameId - El ID del juego.
 * @returns {Promise<object>} Las plantillas de loadout para AI.
 */
export const getAILoadoutTemplates = async (gameId) => {
  const response = await api.get(`/api/games/${gameId}/shop/loadout-templates?for=ai`);
  return response.data;
};

// NOTE: applyLoadout moved to shopApi.js - uses loadout_template_id instead of type/value